import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UserContext } from '@irian-ro/util-user';
import { LocalStorageService } from 'ngx-webstorage';

export const signupSubscriptionGuard: CanActivateFn = () => {
  const localStorage = inject(LocalStorageService);
  const userContext = inject(UserContext);

  if(localStorage.retrieve('owner') == null){
      userContext.logout()
      return false;
  }
  return true;
};
